import { simplyClick } from "../../helpers";
import "./Start.scss";

const Start = ({ step, setStep }) => {
  const handleNextStep = () => {
    if (setStep) {
      setStep(step + 1);
      simplyClick("cl_lnd_am31_get_started", null);
    }
  };

  return (
    <div onClick={handleNextStep} className="start__wrap">
      <h2>Join a website where you may find someone special</h2>
      <p>
        Do not give up! A dazzling conversation may be just around the corner.
      </p>
      <button data-cokies="cookies">Get Started</button>
    </div>
  );
};

export default Start;
